import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "@/store/utils/api-route/pembatalanTransaksiAPI";

import { exportKey } from "./state";

const actions = {
  togleFilter: ({ commit }, payload) => {
    commit("setOnFilter", payload);
  },
  toggleSearch: ({ commit }, payload) => {
    commit("toggleOnSearch", payload);
  },
  setSearchKey: ({ commit }, payload) => {
    commit("setSearchKey", payload);
  },
  resetResponse: ({ commit }) => {
    commit("setResponse", {});
  },
  resetSearchKey: ({ commit }) => {
    commit("setSearchKey", "");
  },
  resetListTransaksi: ({ commit }) => {
    commit("resetListTransaksi");
  },
  resetTotalData: ({ commit }) => {
    commit("setTotalData", { jumlah_nota: 0 });
  },
  resetPagination: ({ commit }) => {
    commit("resetPagination");
  },
  toggleExporting: ({ commit }, payload) => {
    commit("setExporting", payload);
  },
  minimizedExport: ({ commit }, payload) => {
    commit("setMinimizedExport", payload);
  },
  exportProgress: ({ commit }, payload) => {
    commit("setExportProgress", payload);
  },
  storeDataDetail: ({ commit }, payload) => {
    commit("setDetailTransaksi", payload);
  },
  multipleExport: ({ commit }, payload) => {
    commit("setMultipleExport", payload);
  },
  setExportData: ({ commit }, payload) => {
    commit("setExportData", payload);
  },
  setExportDataLength: ({ commit }, payload) => {
    commit("setExportDataLength", payload);
  },
  loadListTransaksi: ({ commit, rootGetters, getters }) => {
    let getFilter = rootGetters["filterGlobalModule/getFilter"];
    let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

    let query = {
      key: getters.search.key,
      sort_by: getFilter.sortBy,
      order_by: getFilter.orderBy,
      limit: getters.pagination.limit,
      offset: getters.pagination.offset,
    };

    Object.keys(getFilterItem).forEach((key) => {
      if (getFilterItem[key].length > 0) {
        switch (key) {
          case "statusKonfirmasi":
            query.status_konfirmasi = getFilterItem[key];
            break;
          case "outlet":
            query.outlet_array = getFilterItem[key];
            break;
          case "dataKonsumen":
            query.konsumen_terdaftar_array = getFilterItem[key];
            break;
          case "jenisLayananSnapclean":
            query.jenis_transaksi_array = getFilterItem[key];
            break;
        }
      }
    });

    commit("setFetching", true);
    commit("setUseToastSuccess", false);
    if (getters.listTransaksi.length > 0) {
      commit("setLoadMore", true);
    }
    conn
      .get(api.snapClean.getList, query)
      .then((response) => {
        if (response.status === 200) {
          conn.setQueryString(query);
          commit("updateListTransaksi", response.data);
          commit("setTotalData", response.data);
          commit("setResponse", resulter.successResult(response.data.msg));
          commit("setNextPagination", response.data);
        } else {
          commit("setResponse", resulter.errorResult(response.data.msg));
        }
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("helper/setScrollCalled", false, { root: true });
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setLoadMore", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  loadDetail: ({ commit }, { id }) => {
    let query = { idpenghapusan: id };
    commit("setFetching", true);
    commit("setUseToastSuccess", false);
    conn
      .get(api.snapClean.getDetail, query)
      .then((response) => {
        if (response.data.status) {
          commit("setDetailTransaksi", response.data);
          commit("setResponse", resulter.successResult(response.data.msg));
        } else {
          commit("setResponse", resulter.errorResult(response.data.msg));
        }
        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  updatePembatalan: ({ commit }, data) => {
    commit("setFetching", true);
    commit("setUseToastSuccess", true);
    let {
      snapClean: { approved, decline },
    } = api;
    let { action } = data;
    let posted = new FormData();

    Object.keys(data).forEach(function(key) {
      posted.append(key, data[key]);
    });

    if (!action) {
      commit("setFetching", false);
      commit("setResponse", resulter.errorResult("undefined action"));
      return;
    }

    let callApi = action === "approve" ? approved : action === "decline" ? decline : "";

    conn
      .post(callApi, posted, conn.contentType.form)
      .then((response) => {
        if (response.data.status === true) {
          commit("resetPagination");
          commit("resetListTransaksi");
          commit("setTotalData", { jumlah_nota: 0 });
          commit("setResponse", resulter.successResult(response.data.msg));
        } else {
          commit("setResponse", resulter.errorResult(response.data.msg));
        }
        commit("setFetching", false);
      })
      .catch((e) => {
        commit("setFetching", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  exportData({ commit, rootGetters, getters }) {
    let getFilter = rootGetters["filterGlobalModule/getFilter"];
    let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

    let query = {
      key: getters.search.key,
      sort_by: getFilter.sortBy,
      order_by: getFilter.orderBy,
      limit: getters.pagination.limit,
      offset: getters.pagination.offset,
    };

    Object.keys(getFilterItem).forEach((key) => {
      if (getFilterItem[key].length > 0) {
        switch (key) {
          case "statusKonfirmasi":
            query.status_konfirmasi = getFilterItem[key];
            break;
          case "oultet":
            query.outlet_array = getFilterItem[key];
            break;
          case "dataKonsumen":
            query.konsumen_terdaftar_array = getFilterItem[key];
            break;
          case "jenisLayananSnapclean":
            query.jenis_transaksi_array = getFilterItem[key];
            break;
        }
      }
    });

    let formData = new FormData();
    formData.append("type", exportKey.job);
    formData.append("filter_json", JSON.stringify(query));

    commit("setExporting", true);
    commit("setUseToastSuccess", false);
    conn
      .post(api.snapClean.export.job, formData, conn.contentType.form)
      .then((response) => {
        let { status, msg, data } = response.data;
        if (status === true) {
          localStorage.setItem("key_export_transaksi", exportKey.tracker);
          commit("setResponse", resulter.successResult(msg));
        } else {
          commit("setResponse", resulter.errorResult(msg, data));
          commit("setExporting", false);
        }
      })
      .catch((e) => {
        commit("setExporting", false);
        commit("setResponse", resulter.errorResult(e));
      });
  },
  async exportTracker({ commit }) {
    commit("setUseToastSuccess", false);
    try {
      let keyExport = localStorage.getItem("key_export_transaksi");
      if (keyExport === null) {
        return resulter.errorResult();
      }
      let query = {
        key: keyExport,
      };

      const tracker = await conn.get(api.snapClean.export.track, query);

      if (!tracker.data) {
        throw tracker;
      }

      if (tracker.data.status) {
        return resulter.successResult(tracker.data.msg, tracker.data.data);
      } else {
        return resulter.errorResult(tracker.data.msg, tracker.data.data);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },
  async exportDeleteMaster({ commit }) {
    commit("setUseToastSuccess", false);
    try {
      let keyExport = localStorage.getItem("key_export_transaksi");
      let query = {
        key: keyExport,
      };
      const res = await conn.get(api.snapClean.export.delete.master, query);
      if (!res.data) {
        throw res;
      }
      if (res.data.code === 200) {
        localStorage.removeItem("key_export_transaksi");
        return resulter.successResult(res.data.msg, res.data.data);
      } else {
        return resulter.errorResult(res.data.msg, res.data.data);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },
  async exportDeleteCluster({ commit }, key) {
    commit("setUseToastSuccess", false);
    try {
      let query = {
        key,
      };
      const res = await conn.get(api.reguler.export.delete.cluster, query);
      if (!res.data) {
        throw res;
      }

      if (res.data.code === 200) {
        return resulter.successResult(res.data.msg, res.data.data);
      } else {
        return resulter.errorResult(res.data.msg, res.data.data);
      }
    } catch (e) {
      return resulter.errorResult(e);
    }
  },
};

export default actions;
